import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Gallery } from './components/sections/Gallery';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { Offers } from './components/sections/Offers';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCta } from './components/ui/StickyCta';
const PIXEL_ID = '2411207615977952';
interface AppProps {
  /** Barra sticky inferior en móvil que lleva a las ofertas. */
  showStickyCta?: boolean;
}
export function App({
  showStickyCta = true
}: AppProps) {
  useEffect(() => {
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-cream" data-id="element-0" data-mp="4wvvprmowg9">
      <main data-id="element-1" data-mp="7svdij4jt6t">
        <Hero data-id="element-2" data-mp="2zl3cxocsjc6w" />
        <Problem data-id="element-3" data-mp="2zllduyaeeel5" />
        <Gallery data-id="element-4" data-mp="2zm4wyibsb90r" />
        <WhatYouGet data-id="element-5" data-mp="2zmo6pbra6r3p" />
        <Offers data-id="element-6" data-mp="2zn66ujh2dpgw" />
        <FAQ data-id="element-7" data-mp="33mowfsjtyoq2" />
        <FinalCTA data-id="element-8" data-mp="33m5a7zn5de68" />
      </main>

      <Footer data-id="element-9" data-mp="33ngfy505kvzz" />
      {showStickyCta && <StickyCta data-id="element-10" data-mp="33oi2b5mmd4x0" />}

      <noscript data-id="element-11" data-mp="38m1elzzrb7mb">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-12" data-mp="38li8dgjgy7o4" />
      </noscript>
    </div>;
}